<div class="currency-select">
    <div class="selected" (click)="toggle()"  tcClickOutSide (clickOutside)="hideList($event)">
        <img [src]="selected.currencyLightIcon">
      <span>{{selected.currencyCode}}</span>
      <i class="fa-sharp fa-regular fa-angle-down" [ngClass]="{'rotate-180': showList}"></i>
    </div>
    <div class="list" [ngClass]="{'hide ': !showList}"> 
      <div class="item" *ngFor="let item of wallets" (click)="selectItem(item)">
        <div class="info">
          <div>
            <img [src]="item.currencyLightIcon">
            <span>{{item.walletName}}</span>
          </div>
          
          <span class="account-number">{{item.accountNumber}}</span>
        </div>
        <div class="balance">{{item.balance | tcCurrency: item.precision}} {{item.currencyCode}}</div>
      </div>

    </div>
  </div>
